import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Button from 'components/theme/Button'
import { withRouter } from 'react-router-dom'
import language from 'utils/vast-languagepack'
import { stepperIncrease } from 'actions/view'
import { last } from 'lodash'
import { Hidden, IconButton, withStyles, Typography } from '@material-ui/core'
import { ArrowForwardIos, Save, Done, Send } from '@material-ui/icons'
import {
  createTemplate,
  updateTemplate,
  receiveTemplate,
} from 'actions/template'
import { createOrUpdateSmsTemplate } from 'actions/sms'
import SchedulingDialog from 'components/Inbox/SchedulingDialog'
import { toggleDialog } from 'actions/view'
import Select from 'components/AddOrEditTaskPage/Select'
import { handleMultiChange } from 'actions/tasks'
import FromNumberSelect from 'components/AddOrEditTaskPage/FromNumberSelect'
import FromEmailSelect from 'components/AddOrEditTaskPage/FromEmailSelect'

export default withRouter(
  connect(
    state => ({
      splitFormDisplayed: state.tasks.addOrEdit.splitFormDisplayed,
      selectedActionPrediction:
        state.tasks.addOrEdit.fields.selectedActionPrediction.value,
      lastCardSelected: last(state.email.cardSelected),
    }),
    dispatch =>
      bindActionCreators(
        {
          stepperIncrease,
          createTemplate,
          updateTemplate,
          receiveTemplate,
          createOrUpdateSmsTemplate,
          toggleDialog,
          handleMultiChange,
        },
        dispatch,
      ),
  )(
    withStyles(theme => ({
      sideButton: {
        height: '36.5px',
        [theme.breakpoints.down('sm')]: {
          height: 32,
        },
      },
    }))(
      ({
        templateID,
        history,
        // modal,
        stepsLength,
        stepper,
        stepperIncrease,
        lastCardSelected,
        createTemplate,
        updateTemplate,
        receiveTemplate,
        createOrUpdateSmsTemplate,
        classes,
        toggleDialog,
        handleMultiChange,
      }) => {
        const onFinalStep = stepper === stepsLength - 1

        return (
          <Fragment>
            <Hidden smDown>
              <Button
                size="medium"
                style={{
                  backgroundColor: onFinalStep ? '#18b940' : '#014c94',
                  color: '#fff',
                  borderTopLeftRadius: 35,
                  borderBottomLeftRadius: 35,
                  borderTopRightRadius:
                    onFinalStep &&
                    templateID !== 'new' &&
                    templateID !== 'preload'
                      ? 0
                      : 35,
                  borderBottomRightRadius:
                    onFinalStep &&
                    templateID !== 'new' &&
                    templateID !== 'preload'
                      ? 0
                      : 35,
                  marginTop: 3,
                }}
                variant="contained"
                color="secondary"
                onClick={() => {
                  if (onFinalStep) {
                    if (lastCardSelected === 'sms') {
                      createOrUpdateSmsTemplate(templateID).then(payload => {
                        if (templateID === 'new' || templateID === 'preload') {
                          history.replace(`/templates/sms/${payload.id}`)
                          receiveTemplate({ ...payload, type: 'sms' })
                        }
                      })
                    } else {
                      if (templateID === 'new' || templateID === 'preload') {
                        createTemplate().then(payload => {
                          if (payload.id) {
                            history.replace(`/templates/email/${payload.id}`)
                            receiveTemplate({ ...payload, type: 'email' })
                          }
                        })
                      } else {
                        updateTemplate()
                      }
                    }
                  } else {
                    stepperIncrease('template')
                  }
                }}
              >
                {onFinalStep
                  ? templateID === 'new' || templateID === 'preload'
                    ? language.task.add.create
                    : 'Update'
                  : language.task.add.next}
              </Button>
              {onFinalStep &&
                templateID !== 'new' &&
                templateID !== 'preload' && (
                  <Button
                    onClick={() =>
                      toggleDialog({ dialog: 'scheduling', open: true })
                    }
                    variant="contained"
                    color="secondary"
                    style={{
                      backgroundColor: '#18b940',
                      color: '#fff',
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      borderTopRightRadius: 35,
                      borderBottomRightRadius: 35,
                      padding: 6,
                      minWidth: 0,
                      marginTop: 3,
                    }}
                    className={classes.sideButton}
                  >
                    <Send />
                  </Button>
                )}
            </Hidden>
            <Hidden mdUp>
              {onFinalStep &&
                templateID !== 'new' &&
                templateID !== 'preload' && (
                  <IconButton
                    size="small"
                    variant="contained"
                    color="secondary"
                    style={{
                      backgroundColor: '#18b940',
                      fontSize: 8,
                      padding: 5,
                      color: '#fff',
                      marginTop: 3,
                      marginRight: 8,
                    }}
                    onClick={() =>
                      toggleDialog({ dialog: 'scheduling', open: true })
                    }
                  >
                    <Send />
                  </IconButton>
                )}
              <IconButton
                size="small"
                style={{
                  backgroundColor: onFinalStep ? '#18b940' : '#014c94',
                  fontSize: 8,
                  padding: 5,
                  color: '#fff',
                  marginTop: 3,
                }}
                variant="contained"
                color="secondary"
                onClick={() => {
                  if (onFinalStep) {
                    if (lastCardSelected === 'sms') {
                      createOrUpdateSmsTemplate(templateID).then(payload => {
                        if (templateID === 'new' || templateID === 'preload') {
                          history.replace(`/templates/sms/${payload.id}`)
                          receiveTemplate({ ...payload, type: 'sms' })
                        }
                      })
                    } else {
                      if (templateID === 'new' || templateID === 'preload') {
                        createTemplate().then(payload => {
                          if (payload.id) {
                            history.replace(`/templates/email/${payload.id}`)
                            receiveTemplate({ ...payload, type: 'email' })
                          }
                        })
                      } else {
                        updateTemplate()
                      }
                    }
                  } else {
                    stepperIncrease('template')
                  }
                }}
              >
                {onFinalStep ? (
                  templateID === 'new' || templateID === 'preload' ? (
                    <Done />
                  ) : (
                    <Save />
                  )
                ) : (
                  <ArrowForwardIos />
                )}
              </IconButton>
            </Hidden>
            <SchedulingDialog
              closeFn={() => handleMultiChange([])}
              disabledState={state => {
                return !state.tasks.addOrEdit.select.value?.length
              }}
              dialogType="template"
            >
              <div style={{ padding: 10 }}>
                <Typography variant="h6">Select your recipients</Typography>
                <Select phoneOrEmail={lastCardSelected} />
              </div>
              {lastCardSelected === 'sms' && (
                <div style={{ padding: 10 }}>
                  <Typography variant="h6">
                    What number do you want to send from?
                  </Typography>
                  <FromNumberSelect />
                </div>
              )}
              {(lastCardSelected === 'email' ||
                lastCardSelected === 'blank') && (
                <div style={{ padding: 10 }}>
                  <Typography variant="h6">
                    Which email address should we send this email from?
                  </Typography>
                  <FromEmailSelect />
                </div>
              )}
            </SchedulingDialog>
          </Fragment>
        )
      },
    ),
  ),
)
